import styled from 'styled-components';

export const PartializedLoadsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`;

export const AccordionRoot = styled.div`
  border: 1px solid ${({ theme }) => theme.tokens.color.border.primary};
  border-radius: 0.25rem;
  background-color: ${({ theme }) => theme.tokens.color.surface.primary};
  overflow: hidden;
  box-shadow: none;
`;

export const AccordionHeaderButton = styled.button<{ $expanded: boolean }>`
  width: 100%;
  text-align: left;
  margin: 0;
  padding: 1rem;
  min-height: auto;
  background-color: transparent;
  border: none;
  border-bottom: ${({ $expanded, theme }) =>
    $expanded ? `1px solid ${theme.tokens.color.border.primary}` : 'none'};
  font-family: 'LATAM Sans Regular', 'LATAM Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;
  cursor: pointer;
  color: ${({ theme }) => theme.tokens.color.text.primary};

  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  box-sizing: border-box;

  &:hover {
    background-color: ${({ theme }) => theme.tokens.color.background.secondary};
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.tokens.color.border.focusStandard};
    outline-offset: -2px;
  }
`;

export const AccordionChevron = styled.span<{ $expanded: boolean }>`
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.tokens.color.text.primary};
  flex-shrink: 0;
  transition: transform 0.2s ease;
  transform: rotate(${({ $expanded }) => ($expanded ? '180deg' : '0deg')});
`;

export const AccordionPanel = styled.div`
  padding: 1rem;
`;

export const AccordionHeaderContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  flex: 1;
  width: 100%;
  min-width: 0;
`;

export const AccordionTitle = styled.span`
  font-size: 0.875rem;
  font-weight: 600;
  color: ${({ theme }) => theme.tokens.color.text.primary};
  font-family: 'LATAM Sans Regular', 'LATAM Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;
`;

export const PiecesBadge = styled.div<{ variant?: 'previous' | 'new' }>`
  display: flex;
  align-items: center;
  gap: 0.25rem;
  margin-right: 0.5rem;
  background-color: ${({ variant, theme }) => variant === 'previous' ? theme.tokens.color.neutral['200'] : theme.tokens.color.surface.infoSoft};
  color: ${({ theme }) => theme.tokens.color.text.primary};
  padding: 0.25rem 0.75rem;
  border-radius: 9999px;
  font-size: 0.875rem;
  font-weight: bold;
  font-family: 'LATAM Sans Regular', 'LATAM Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;
  white-space: nowrap;
`;

export const AccordionContentInner = styled.div<{ variant?: 'previous' | 'new' }>`
  padding: 0;
  border-left: 6px solid ${({ variant, theme }) => {
    return variant === 'previous' ? theme.tokens.color.neutral['200'] : theme.tokens.color.interaction.mediumDefault;
  }};
  border-radius: 0.25rem;
`;

export const PartializedSegmentsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0;
  padding: 0;
  
  & > div:first-child {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    border-left: none;
  }
  
  & > div:last-child {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }
  
  & > div {
    border-left: none;
  }
`;

export const EmptySegmentsMessage = styled.div`
  font-size: 0.875rem;
  color: ${({ theme }) => theme.tokens.color.text.secondary};
  font-style: italic;
  padding: 1rem;
  text-align: center;
  font-family: 'LATAM Sans Regular', 'LATAM Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;
`;
